
import React, { useEffect, useState } from "react";

const SmartHireLoader = ({ message = "Loading" }) => {
  const styles = {
    container: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100vh",
      backgroundColor: "transparent",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Inter, Roboto, sans-serif',
    },
    loaderContainer: {
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    sIcon: {
      width: "80px",
      height: "80px",
      backgroundColor: "#0017E7",
      borderRadius: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "42px",
      fontWeight: "700",
      color: "#FFFFFF",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      animation: "smoothPulse 3s cubic-bezier(0.4, 0, 0.2, 1) infinite",
      transformStyle: "preserve-3d",
      willChange: "transform, box-shadow",
      boxShadow: "0 8px 32px rgba(24, 160, 251, 0.25)",
      position: "relative",
    },
    sText: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "42px",
      fontWeight: "700",
      color: "#FFFFFF",
      animation: "stableS 3s cubic-bezier(0.4, 0, 0.2, 1) infinite",
      willChange: "transform",
      fontFamily:'Kontora'
    },
    message: {
      color: "#fff",
      fontSize: "14px",
      fontWeight: "400",
      opacity: 0.8,
      letterSpacing: "0.2px",
      marginTop: "32px",
      animation: "textFade 3s cubic-bezier(0.4, 0, 0.2, 1) infinite",
    },
  };

  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <style>{`
        @keyframes smoothPulse {
          0%, 100% {
            transform: perspective(500px) scale(1) rotateY(0deg) rotateX(0deg);
            box-shadow: 0 8px 32px rgba(24, 160, 251, 0.25);
            background-color: #0017E7;
            border-radius: 20px;
          }
          50% {
            transform: perspective(500px) scale(1.12) rotateY(0deg) rotateX(0deg);
            box-shadow: 0px 0px 64px #82baffff;
            background-color: #0064e7ff;
            border-radius: 25px;
          }
        }

        @keyframes stableS {
          0%, 100% {
            transform: translate(-50%, -50%) scale(0.893) perspective(500px) rotateY(0deg) rotateX(0deg);
          }
          50% {
            transform: translate(-50%, -50%) scale(1) perspective(500px) rotateY(0deg) rotateX(0deg);
          }
        }

        @keyframes textFade {
          0%, 100% {
            opacity: 0.6;
          }
          50% {
            opacity: 1;
          }
        }
      `}</style>
      <div style={styles.container}>
        <div style={styles.loaderContainer}>
          <div style={styles.sIcon}>
            <div style={styles.sText}>S</div>
          </div>
          {message && (
            <div style={styles.message}>{message + ".".repeat(dotCount)}</div>
          )}
        </div>
      </div>
    </>
  );
};

export default SmartHireLoader;